export default {
  strict: true,
  namespaced: true,
  state: {
    averageReviews: 0,
    fiveStarReviews: 0,
    totalReviews: 0,
    reviews: [],
    reviewMax: false,
    reviewPage: 0,
    reviewsPerPage: 20
  },
  mutations: {
    resetStatsReviews (state) {
      state.averageReviews = 0
      state.fiveStarReviews = 0
      state.totalReviews = 0
    },
    setAverageTotalReviews (state, value) {
      state.averageReviews = value.average
      state.totalReviews = value.total
    },
    setFiveStarReview (state, value) {
      state.fiveStarReviews = value
    },
    resetReviews (state) {
      state.reviews = []
    },
    addReviews (state, value) {
      state.reviews.push(value)
    },
    setReviewMax (state, value) {
      state.reviewMax = value
    },
    setReviewPage (state, value) {
      state.reviewPage = value
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/provider/reviews.js